(ns practitest.frontend.ptql.parser
  (:require
    [instaparse.core :as insta])
  (:require-macros [practitest.frontend.ptql.parser-macros :refer [slurp-ebnf]]))

(def ptql-parser
  (insta/parser (slurp-ebnf "ptql.ebnf") :auto-whitespace :standard))

(defn parse
  "Parse a PTQL string. Returns parse tree or failure."
  [input]
  (insta/parse ptql-parser input))

(defn failure? [result]
  (insta/failure? result))

(defn get-expected
  "Given a parse failure, return the set of expected tokens/rules."
  [result]
  (when (insta/failure? result)
    (->> (insta/get-failure result)
         :reason
         (map (fn [{:keys [tag expecting]}]
                (case tag
                  :string expecting ;; literal like "IS, "=", etc
                  :regexp (str expecting) ;; preserve regex string
                  :nt (name expecting) ;; "field-name", "value", etc
                  expecting)))
         (set))))

(defn get-failure-index [result]
  (when (insta/failure? result)
    (:index (insta/get-failure result))))

(comment
  (parse "'External ID' IS EMPTY AND Name STARTS WITH \"New Markets\""))
